<template>
  <div
    style="background-color: #f4f4f4;position: fixed;z-index: 11111;;width: 100vw;height: 100vh;overflow-y: auto;top: 0;left: 0;">
    <div>
      <van-nav-bar :title="$t('addresspop.select_area')" fixed class="nav-bar">
        <template #right>
          <div @click="onClickLeft" style="font-size: 14px;">{{ $t('addresspop.all_area') }}</div>
        </template>
      </van-nav-bar>
    </div>
    <div class="pop_container">
      <div class="cityBox">
        <div class="item" v-for="item in addressList" :key="item.id" @click="choose(item)">{{item.name}}</div>
      </div>
    </div>
    <div style="padding-bottom: 20vw; background-color: transparent;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list:[]
    };
  },
  props: ['addressList'],
  created(){
      
  },
  methods: {
    choose(item){
      this.$emit('addressChange',item)
      this.$emit('close')
    },
    onClickLeft() {
      this.$emit('close')
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: #fff;
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: #fff;
  border-bottom-width: 0;
}

.pop_container {
  padding: 100px 0;
}
.pop_container .cityBox {
  padding: 16px 30px;
  display: flex;
  flex-wrap: wrap;
}
.pop_container .cityBox .item {
  width: 152px;
  height: 52px;
  line-height: 52px;
  border-radius: 6px;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  overflow: hidden;
  border: 2px solid #F297A2;
  box-sizing: border-box;
  color: #F297A2;
  margin-top: 24px;
  margin-right: 24px;
  &:nth-child(4n) {
    margin-right: 0;
}
}

</style>
